import(/* webpackMode: "eager" */ "/home/aries/adlily/apps/v2/src/app/global-error.tsx");
